import { render, staticRenderFns } from "./packageOperation.vue?vue&type=template&id=10923d4c&scoped=true&"
import script from "./packageOperation.vue?vue&type=script&lang=js&"
export * from "./packageOperation.vue?vue&type=script&lang=js&"
import style0 from "./packageOperation.vue?vue&type=style&index=0&id=10923d4c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10923d4c",
  null
  
)

export default component.exports